export const environment = {
	production: true,
	appVersion: "v726demo1",
	USERDATA_KEY: "authf649fc9a5f55",
	isMockEnabled: true,
	apiUrl: "api",
	backend_server: "https://backend.simplefactura.cl/api",
	signalR_server: "https://alerthub.simplefactura.cl/alertahub",
	taxPercentage: 0.19,
	country_code_port: 41,
	checkSession: true,
	msal_client_key: "",
	msal_authority: "",
	msal_return_url: "",
	msal_postlogout_redirect_uri: "",
	msal_graph_endpoint: "",
	title: "SimpleFactura",
	idleTimeout: 900,
	logoutTimeout: 30,
	withholdBheValues: [0.13, 0.1375, 0.145, 0.1525, 0.16, 0.17],
	googleMapsApiKey: "AIzaSyDdivpOIC07bxRiAaoQniZr75-AHsMj7sU"
};
 